import { useNavigate } from "react-router";
import { RevButton, RevLink } from "@revmatics/catalyst";
import notFound from "/images/empty_states/404-not-found.svg";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center text-center py-10 min-h-[calc(100dvh-200px)]">
      <img src={notFound} alt="Page Not Found" className="mb-10" />
      <h5 className="!text-monochrome-500">Page Not Found</h5>
      <p className="typography-body-sm text-monochrome-500 mb-3">
        The requested page is not available
      </p>
      <div className="flex gap-3">
        <RevButton
          text="Go Back"
          buttonSize="medium"
          handleClick={() => navigate(-1)}
        />
        <RevLink
          text="Home Page"
          displayAs="button"
          buttonVariant="secondary"
          buttonSize="medium"
          pathname="/personas"
          className="typography-body-bold-sm"
        />
      </div>
    </div>
  );
};
